import { type FC } from "react"

import { type ThinEvent } from "@forento/core/models/event"

import { ControlledTabs } from "~/components/Tabs"

import Event from "./Event"

type Props = { events: ThinEvent[]; onReload(): Promise<unknown> }
const Events: FC<Props> = ({ events, onReload }) => {
	const upcomingEvents = events.filter(event => event.endDate > new Date())
	const pastEvents = events.filter(event => !upcomingEvents.some(upcomingEvent => upcomingEvent.id === event.id))

	return (
		<ControlledTabs
			tabs={[
				{
					title: "Upcoming",
					sticker: upcomingEvents.length.toString(),
					content: (
						<div className="mt-4 flex flex-col gap-2">
							{upcomingEvents.map(event => (
								<Event key={event.id} event={event} onReload={onReload} />
							))}
						</div>
					),
				},
				{
					title: "Past",
					sticker: pastEvents.length.toString(),
					content: (
						<div className="mt-4 flex flex-col gap-2">
							{pastEvents.map(event => (
								<Event key={event.id} event={event} onReload={onReload} />
							))}
						</div>
					),
				},
			]}
		/>
	)
}

export default Events
